import { useEventBus } from '@vueuse/core';

/** @description Event that is fired when backend is changed */
const backendChanged = useEventBus<void>('backendChanged');

/**
 * @description Exposes application events
   @returns {Object} Object with application events
 */
export function useApplicationEvents() {
  return { backendChanged };
}
